import { SET_PROJECTS, UPDATE_PROJECTS_LIST } from './types'

const competitionsState = {
    projects: [],
}

const updateProjectList = (oldList, currentList) => {

  const result = [ ...oldList, ...currentList ]

  let filter = result.filter((cur, i, a)=> a.findIndex(item => (item._id === cur._id) ) === i)

  return filter
  
}

const competitionsReducer = (state, actions) => {
    const { type, payload } = actions

    switch (type) {
        case SET_PROJECTS:
          return {
              ...state,
              projects: payload,
          }
        case UPDATE_PROJECTS_LIST: {
            return {
                ...state,
                projects: updateProjectList(state.projects, payload)
            }
        }
        default: {
          return state
        }
    }
}

export { competitionsReducer as default, competitionsState }